"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radioTheme = void 0;

var _checkboxTheme = require("../Checkbox/checkboxTheme");

var radioTheme = function radioTheme(theme) {
  return {
    root: {
      '&.MuiIconButton-root': (0, _checkboxTheme.iconActionStyle)(theme)
    }
  };
};

exports.radioTheme = radioTheme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1JhZGlvL3JhZGlvVGhlbWUudHN4Il0sIm5hbWVzIjpbInJhZGlvVGhlbWUiLCJ0aGVtZSIsInJvb3QiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFFQTs7QUFHTyxJQUFNQSxVQUFVLEdBQUcsU0FBYkEsVUFBYSxDQUFDQyxLQUFEO0FBQUEsU0FBa0U7QUFDMUZDLElBQUFBLElBQUksRUFBRTtBQUNKLDhCQUF3QixvQ0FBZ0JELEtBQWhCO0FBRHBCO0FBRG9GLEdBQWxFO0FBQUEsQ0FBbkIiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBSYWRpb0NsYXNzS2V5IH0gZnJvbSAnQG1hdGVyaWFsLXVpL2NvcmUnO1xuaW1wb3J0IHsgQ1NTUHJvcGVydGllcyB9IGZyb20gJ0BtYXRlcmlhbC11aS9jb3JlL3N0eWxlcy93aXRoU3R5bGVzJztcbmltcG9ydCB7IGljb25BY3Rpb25TdHlsZSB9IGZyb20gJy4uL0NoZWNrYm94L2NoZWNrYm94VGhlbWUnO1xuaW1wb3J0IHsgVGhlbWUgfSBmcm9tICcuLi9UaGVtZS90aGVtZSc7XG5cbmV4cG9ydCBjb25zdCByYWRpb1RoZW1lID0gKHRoZW1lOiBUaGVtZSk6IFBhcnRpYWw8UmVjb3JkPFJhZGlvQ2xhc3NLZXksIENTU1Byb3BlcnRpZXM+PiA9PiAoe1xuICByb290OiB7XG4gICAgJyYuTXVpSWNvbkJ1dHRvbi1yb290JzogaWNvbkFjdGlvblN0eWxlKHRoZW1lKSxcbiAgfSxcbn0pO1xuIl19